import { ComponentType } from "react";

import {
    Location,
    NavigateFunction,
    Params,
    useLocation,
    useNavigate,
    useParams,
} from "react-router-dom";

export interface WithRouterProps {
    navigate: NavigateFunction;
    location: Location;
}

// NOTE: Since we use many class components and hooks cannot be used there,
// we create these HOCs to inject router props into class components.
export function withRouter<P>(
    Component: ComponentType<P & { navigate: ReturnType<typeof useNavigate> }>
) {
    return function (props: Omit<P, "navigate" | "location">) {
        const navigate = useNavigate();
        const location = useLocation();
        return (
            <Component
                {...(props as P)}
                navigate={navigate}
                location={location}
            />
        );
    };
}

export function withParams<P>(
    Component: ComponentType<P & { params: Params }>
) {
    return function (props: Omit<P, "params">) {
        const params = useParams();
        if (!params) {
            throw new Error("No params found");
        }
        return <Component {...(props as P)} params={params} />;
    };
}

export function withIdParams<P>(Component: ComponentType<P & { id: string }>) {
    return function (props: Omit<P, "id">) {
        const { id } = useParams();
        if (!id) {
            throw new Error("No id param found");
        }
        return <Component {...(props as P)} id={id} />;
    };
}
